/** @jsx jsx */
import { jsx } from 'theme-ui';
import View from '../View/View';

export default function Container({ fluid, ...rest }) {
  return (
    <View
      sx={{
        maxWidth: fluid
          ? undefined
          : [
              'container.mobile',
              'container.tablet',
              'container.default',
              'container.large',
            ],
        marginX: 'auto',
        paddingX: 'gutter',
        boxSizing: 'border-box',
      }}
      {...rest}
    />
  );
}
